import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Typography, Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    gridContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: 'auto',
        border: '1px solid #ced4da',
        background: '#fff',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
        width: '60%',
        marginLeft: 'auto',
        marginRight: 'auto',
        }
    },

    gridItem: {
        height: '100%', 
        padding: '0px',
        background: '#FFFFFF',
    },

    select: {
        height: '100%', 
        padding: '0 10px',
    },

    button: {
        width: '94%',
        background: '#15616d',
        color: 'grey',
        textTransform: 'capitalize',
        '&:hover': {
            // background: '#40916c',
            cursor: 'default',
            background: '#15616d',
        },
        '&:focus':{
            outline: 'none'
        }
    },   
}))

function HompageSearchBar() {
    const classes = useStyles();

    return (
        <>
            {/******************  START WHERE SEARCHBAR  ****************************/}
            <Grid container spacing={3} className={classes.gridContainer}>
                <Grid item xs={12} md={5} className={classes.gridItem} style={{padding: '20px 0 0 0'}}>
                        <Select
                            className={classes.select}
                            required 
                            // value={auctionInfo.category}
                            id="category_id"
                            name="category"
                            label="Category"
                            fullWidth
                            // onChange={e => setAuctionInfo({...auctionInfo, category: e.target.value})}
                            fullWidth
                        >
                            <MenuItem value="Cars">Frankfurt</MenuItem>
                            <MenuItem value="Mortobikes and bicycles">Köln</MenuItem>
                            <MenuItem value="Furniture">Hamburg</MenuItem>
                            <MenuItem value="Clothings">Berlin</MenuItem>
                            <MenuItem value="Clothings">Düsseldorf</MenuItem>
                        </Select>
                    </Grid>
                    {/****************** END WHERE SEARCHBAR  ****************************/}

                    {/****************** START SEARCH COMPANY SEARCHBAR  ****************************/}
                <Grid item xs={12} md={5} className={classes.gridItem} style={{padding: '20px 0 0 0', borderLeft: '1px solid #ced4da'}}>
                        <Select
                            className={classes.select}
                            required
                            // value={auctionInfo.category}npm
                            id="category_id"
                            name="category"
                            label="Category"
                            fullWidth
                            // onChange={e => setAuctionInfo({...auctionInfo, category: e.target.value})}
                            fullWidth
                        >
                            <MenuItem value="Cars">Brücke GmbH</MenuItem>
                            <MenuItem value="Mortobikes and bicycles">Umzugusleute GmbH</MenuItem>
                            <MenuItem value="Furniture">Transporex GmbH</MenuItem>
                            <MenuItem value="Clothings">Sarafina Co.Ltd.</MenuItem>
                            <MenuItem value="Clothings">Cargo Co.Ltd.</MenuItem>
                        </Select>
                    </Grid>
                    {/****************** START SEARCH COMPANY SEARCHBAR  ****************************/}

                    <Grid item xs={12} md={2} className={classes.gridItem} style={{padding: '11px 11px 11px 25px'}}>
                        <Button variant='contained' disableRipple='true' size="large" className={classes.button}>
                            Search
                        </Button>
                    </Grid>
            </Grid>
        </>
    )
}

export default HompageSearchBar;
